import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";
import "./PaymentPlanWindow.css";
import { useWindowSize } from "../hooks/windowSize";
import Swal from "sweetalert2";

function PaymentPlanWindow({
  onClose,
  selectedSystemName = "250,000 BPD Offshore Production DCS",
  userId
}) {

  console.log("Payment Plan Window", selectedSystemName.includes("Refinery"))
  console.log(selectedSystemName)

  console.log(userId)
  const { width, height, isMobile, isTablet, isDesktop } = useWindowSize();
  const deviceType = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const navigate = useNavigate();

  // =====================================================
  // DRAG STATE
  // =====================================================
  const [pos, setPos] = useState({ x: 180, y: 70 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const startDrag = (e) => {
    if (isMobile) return; // Disable drag on mobile
    setDragging(true);
    setOffset({
      x: e.clientX - pos.x,
      y: e.clientY - pos.y,
    });
  };

  const onMove = (e) => {
    if (!dragging || isMobile) return;
    setPos({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y,
    });
  };

  const stopDrag = () => setDragging(false);

  // =====================================================
  // LOGIN ALERT
  // =====================================================
  const loginAlert = () => {
    setIsAlertOpen(true);
    
    const ensureSwalOnTop = () => {
      setTimeout(() => {
        const swalContainer = document.querySelector('.swal2-container');
        if (swalContainer) {
          swalContainer.style.zIndex = '9999999999';
        }
      }, 10);
    };

    if (deviceType === "Mobile") {
      Swal.fire({
        title: "Mobile Access Detected",
        text: "You cannot login on a mobile device.",
        icon: "info",
        confirmButtonText: "OK"
      });
      ensureSwalOnTop();
      return;
    } else if (deviceType === "Tablet") {
      Swal.fire({
        title: "Tablet Access Detected",
        text: "You cannot login on a tablet device.",
        icon: "info",
        confirmButtonText: "OK"
      });
      ensureSwalOnTop();
      return;
    }


    if (selectedSystemName.includes("Offshore")) {



    Swal.fire({
      title: "Access Restricted",
      text: "This simulator is in testing stage. Please enter the access password.",
      icon: "info",
      input: "password",
      inputPlaceholder: "Enter password",
      inputAttributes: {
        autocapitalize: "off",
        autocorrect: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Access Simulator",
      cancelButtonText: "Cancel",
      preConfirm: (password) => {
        if (!password) {
          Swal.showValidationMessage("Password is required");
          return false;
        }
        return password;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const enteredPassword = result.value;
        const correctPassword = "testdcs123";

        if (enteredPassword === correctPassword) {
          Swal.fire({
            icon: "success",
            title: "Access Granted",
            text: "Redirecting to Offshore DCS Simulator...",
            timer: 1500,
            showConfirmButton: false
          }).then(() => {
            navigate("/WellComp", { state: { fromLogin: true } });
            setIsAlertOpen(false);
          });
          ensureSwalOnTop();
        } else {
          Swal.fire({
            icon: "error",
            title: "Wrong Password",
            text: "Incorrect password. Please contact your instructor for access.",
            confirmButtonText: "Try Again"
          }).then(() => {
            loginAlert();
          });
          ensureSwalOnTop();
        }
      }
    });

  } else if (selectedSystemName.includes("Refinery")) {

    console.log("Refinery")

    Swal.fire({
      title: "Access Restricted",
      text: "This simulator is in testing stage. Please enter the access password.",
      icon: "info",
      input: "password",
      inputPlaceholder: "Enter password",
      inputAttributes: {
        autocapitalize: "off",
        autocorrect: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Access Simulator",
      cancelButtonText: "Cancel",
      preConfirm: (password) => {
        if (!password) {
          Swal.showValidationMessage("Password is required");
          return false;
        }
        return password;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const enteredPassword = result.value;
        const correctPassword = "testdcs123";

        if (enteredPassword === correctPassword) {
          Swal.fire({
            icon: "success",
            title: "Access Granted",
            text: "Redirecting to Refinery Simulator...",
            timer: 1500,
            showConfirmButton: false
          }).then(() => {
            
            setIsAlertOpen(false);
            window.location.href = `https://refinery.nktechhub.com/?user=${userId}`;
          });
          ensureSwalOnTop();
        } else {
          Swal.fire({
            icon: "error",
            title: "Wrong Password",
            text: "Incorrect password. Please contact your instructor for access.",
            confirmButtonText: "Try Again"
          }).then(() => {
            loginAlert();
          });
          ensureSwalOnTop();
        }
      }
    });
  }
    
    ensureSwalOnTop();
  };

  // =====================================================
  // MASTER PAYMENT PLAN DATA
  // =====================================================

  const allPlans = {
    "250,000 BPD Offshore Production DCS": [
      {
        name: "Visitor Level (Free)",
        color: "#00d4ff",
        duration: "20 Minutes Session",
        price: "FREE",
        features: [
          { label: "NK-1 Wellhead Access", value: true },
          { label: "Single Screen Operation", value: true },
          { label: "Control Valves / Chokes", value: true },
          { label: "PID Auto / Manual", value: true },
          { label: "Trend Viewing", value: true },
          { label: "Export Charts", value: true },
          { label: "8 Screen Navigation", value: false },
          { label: "Full Plant Operations", value: false },
        ],
      },
      {
        name: "Operator Training Package",
        color: "#00ff88",
        duration: "Unlimited Access",
        price: "$$$ / Month",
        features: [
          { label: "8 Process Screens", value: true },
          { label: "Separator Operations", value: true },
          { label: "Pigging Operations", value: true },
          { label: "Level / Pressure Control", value: true },
          { label: "Test Separator Use", value: true },
          { label: "Alarm Handling", value: true },
          { label: "Reservoir Editing", value: false },
          { label: "Full Engineering Override", value: false },
        ],
      },
      {
        name: "Process Engineer Suite",
        color: "#ffaa00",
        duration: "Professional Access",
        price: "$$$ / Month",
        features: [
          { label: "All Screens Except Well Composition", value: true },
          { label: "Compressor Systems", value: true },
          { label: "Heat Exchanger Review", value: true },
          { label: "Separator Tuning", value: true },
          { label: "Advanced Trends", value: true },
          { label: "Engineering Reports", value: true },
          { label: "Well Composition Edit", value: false },
          { label: "Reservoir Override", value: false },
        ],
      },
      {
        name: "Enterprise / Plant Engineer",
        color: "#ff3b3b",
        duration: "Full Digital Twin",
        price: "Custom Pricing",
        features: [
          { label: "All Plant + Subsea Systems", value: true },
          { label: "Reservoir Pressure Edit", value: true },
          { label: "Crude Composition Edit", value: true },
          { label: "Water / Gas / Impurity Edit", value: true },
          { label: "Shutdown Logic Access", value: true },
          { label: "Full Engineering Override", value: true },
          { label: "Unlimited Scenario Simulation", value: true },
          { label: "Corporate Deployment", value: true },
        ],
      },
    ],
    "30,000 BPD Modular Refinery": [
      {
        name: "Visitor Level (Free)",
        color: "#00d4ff",
        duration: "15 Minutes Session",
        price: "FREE",
        features: [
          { label: "Crude Heater Screen", value: true },
          { label: "Column Overview", value: true },
          { label: "Manual Valve Use", value: true },
          { label: "Trend View", value: true },
          { label: "Product Routing", value: false },
          { label: "Tank Farm Access", value: false },
          { label: "Alarm Response", value: false },
          { label: "Engineering Mode", value: false },
        ],
      },
      {
        name: "Operator Training Package",
        color: "#00ff88",
        duration: "Unlimited Access",
        price: "$$$ / Month",
        features: [
          { label: "Distillation Operations", value: true },
          { label: "Pump Operations", value: true },
          { label: "Tank Farm Navigation", value: true },
          { label: "Product Transfer", value: true },
          { label: "Alarm System", value: true },
          { label: "Trend Reports", value: true },
          { label: "Yield Optimization", value: false },
          { label: "Engineering Design", value: false },
        ],
      },
      {
        name: "Process Engineer Suite",
        color: "#ffaa00",
        duration: "Engineer Access",
        price: "$$$ / Month",
        features: [
          { label: "Yield Monitoring", value: true },
          { label: "Energy Efficiency", value: true },
          { label: "Column Balance", value: true },
          { label: "Heat Duty Review", value: true },
          { label: "Reports Export", value: true },
          { label: "Advanced Trends", value: true },
          { label: "Crude Assay Edit", value: false },
          { label: "Full Plant Override", value: false },
        ],
      },
      {
        name: "Enterprise / Plant Engineer",
        color: "#ff3b3b",
        duration: "Full Refinery Twin",
        price: "Custom Pricing",
        features: [
          { label: "Crude Assay Editing", value: true },
          { label: "Feed Rate Change", value: true },
          { label: "Product Slate Simulation", value: true },
          { label: "Full Plant Override", value: true },
          { label: "Corporate Multi User", value: true },
          { label: "Shutdown Logic", value: true },
          { label: "Scenario Training", value: true },
          { label: "Unlimited Access", value: true },
        ],
      },
    ],
    "1000 BPD Modular Refinery": [],
    "10,000 BPD Hydroskimming Refinery": [],
    "5,000 BPD Modular Refinery": [],
    "100,000 BPD Conventional Refinery": [],
    "500 MMSCFD Gas Plant": [],
    "2000 MMSCFD Gas Processing Plant": [],
    "5000 MMSCFD LNG Feed Gas Plant": [],
    "100,000 MMSCFD LNG Feed Gas Plant": [],
    "Onshore Production Facility (OPF)": [],
    "Gathering Station System": [],
    "Small Scale Methanol Plant": [],
    "Industrial Methanol Complex": [],
    "Bio-Ethanol Plant": [],
    "Industrial Ethanol Production Unit": [],
  };

  // =====================================================
  // FALLBACK
  // =====================================================
  const defaultPlans = allPlans["250,000 BPD Offshore Production DCS"];
  const plans = allPlans[selectedSystemName] && allPlans[selectedSystemName].length > 0
    ? allPlans[selectedSystemName]
    : defaultPlans;

  // =====================================================
  // FEATURE ROW
  // =====================================================
  const Row = ({ label, value }) => (
    <div className="plan-row">
      <span>{label}</span>
      <span className={value ? "tick" : "cross"}>
        {value ? "✔" : "✖"}
      </span>
    </div>
  );

  // =====================================================
  // GET RESPONSIVE STYLES
  // =====================================================
  const getWindowStyles = () => {
    if (isMobile) {
      return {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95%',
        maxWidth: '400px',
        height: 'auto',
        maxHeight: '90vh',
        overflow: 'auto',
        margin: 0,
        borderRadius: '16px',
        zIndex: 9999,
      };
    } else if (isTablet) {
      return {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '700px',
        height: 'auto',
        maxHeight: '85vh',
        overflow: 'auto',
        margin: 0,
        borderRadius: '14px',
        zIndex: 9999,
      };
    }
    return {
      position: 'absolute',
      left: pos.x,
      top: pos.y,
      width: '1050px',
      maxWidth: '90vw',
      height: '590px',
      maxHeight: '85vh',
      overflow: 'auto',
      borderRadius: '12px',
      zIndex: 9999,
    };
  };

  // =====================================================
  // UI
  // =====================================================

  const modal = (
    <div
      className="payment-overlay"
      onMouseMove={onMove}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
    >
      <div
        className="payment-window"
        style={getWindowStyles()}
      >
        {/* HEADER */}
        <div
          className="payment-header"
          onMouseDown={startDrag}
          style={{
            cursor: isMobile ? 'default' : 'grab',
            padding: isMobile ? '12px 16px' : '0 16px',
            minHeight: isMobile ? '50px' : '55px',
          }}
        >
          <h3 style={{
            fontSize: isMobile ? '13px' : '16px',
            margin: 0,
            wordBreak: 'break-word',
          }}>
            NK Tech DCS - {selectedSystemName}
          </h3>
          <button
            onClick={onClose}
            style={{
              width: isMobile ? '36px' : '30px',
              height: isMobile ? '36px' : '30px',
              fontSize: isMobile ? '20px' : '18px',
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div
          className="plan-container"
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? '12px' : '14px',
            padding: isMobile ? '12px' : '14px',
            height: isMobile ? 'auto' : 'calc(100% - 55px)',
            maxHeight: isMobile ? 'calc(90vh - 60px)' : 'none',
            overflow: 'auto',
          }}
        >
          {plans.map((plan, i) => (
            <div
              key={i}
              className="plan-card"
              style={{
                borderColor: plan.color,
                minHeight: isMobile ? 'auto' : '460px',
                padding: isMobile ? '14px' : '14px 12px',
                borderRadius: '14px',
                background: 'rgba(255,255,255,0.03)',
                border: `1px solid ${plan.color}`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transition: 'all 0.25s ease',
              }}
            >
              <div
                className="plan-title"
                style={{
                  color: plan.color,
                  fontSize: isMobile ? '16px' : '15px',
                  fontWeight: 700,
                  marginBottom: '6px',
                  lineHeight: 1.3,
                }}
              >
                {plan.name}
              </div>

              <div
                className="plan-duration"
                style={{
                  fontSize: isMobile ? '12px' : '12px',
                  color: '#b8c7d6',
                  marginBottom: '6px',
                }}
              >
                {plan.duration}
              </div>

              <div
                className="plan-price"
                style={{
                  fontSize: isMobile ? '20px' : '18px',
                  fontWeight: 800,
                  color: '#ffffff',
                  marginBottom: '10px',
                }}
              >
                {plan.price}
              </div>

              <div
                className="plan-features"
                style={{
                  marginTop: '10px',
                  fontSize: isMobile ? '12px' : '12px',
                  lineHeight: isMobile ? '2' : '2',
                  flex: '1',
                }}
              >
                {plan.features.map((f, idx) => (
                  <Row key={idx} label={f.label} value={f.value} />
                ))}
              </div>

              <button
                className="buy-btn"
                style={{
                  background: plan.color,
                  color: '#001018',
                  border: 'none',
                  padding: isMobile ? '14px' : '11px',
                  borderRadius: '10px',
                  fontSize: isMobile ? '15px' : '13px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  marginTop: '12px',
                  transition: 'all 0.25s ease',
                  boxShadow: '0 0 10px rgba(0,255,255,0.15)',
                }}
                onClick={() => {
                  if (plan.name === "Visitor Level (Free)") {
                    loginAlert();
                    return;
                  }
                  localStorage.setItem("selectedPlan", plan.name);
                  localStorage.setItem("selectedSystem", selectedSystemName);
                  onClose();
                }}
              >
                {plan.name === "Visitor Level (Free)" ? "Login" : "Buy Now"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

export default PaymentPlanWindow;